<template>
  <transition name="assistant">
    <div class="assistant">
      <a-popover placement="leftBottom">
        <template slot="content">
          <p>{{ $t('scope.assistant.tips')}}</p>
          <div style="text-align: right">
            <a-button type="primary" shape="round" size="small" @click="createTicket">
              {{ $t('scope.assistant.confirm')}}
            </a-button>
            <a-button type="link" @click="cancelDialog">
              {{ $t('scope.assistant.ignore')}}
            </a-button>
          </div>
        </template>
        <a-button type="primary" shape="circle" icon="appstore" />
      </a-popover>
    </div>
  </transition>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'CloudpodsAssistantDialog',
  mixins: [DialogMixin, WindowsMixin],
  watch: {
    $route (to, from) {
      this.cancelDialog()
    },
  },
  methods: {
    createTicket () {
      this.createDialog('ExceptionDialog', this.params)
    },
  },
}
</script>

<style lang="less" scoped>
.assistant {
  padding-right: 8px;
  position: fixed;
  right: 0px;
  bottom: 48px;
  z-index: 101;
}

.assistant-enter-active, .assistant-leave-active {
  transition: all .5s ease;
}
.assistant-enter, .assistant-leave-to {
  opacity: 0;
}
</style>
